import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import { Deal } from '@ca/common/types'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import { useDealSelect } from '@order/hooks/useDealTypeModal'
import useStartOrderConfig from '@order/hooks/useStartOrderConfig'
import DealComponent from '@screens/intro/deals/Deal'
import RecommendedBadge from '@order/steps/templates/Recommendation/RecommendationBadge'
import RecommendationButtons from '@order/steps/templates/Recommendation/RecommendationButtons'
import RecommendationRow from '@order/steps/templates/Recommendation/RecommendationRow'
import useNavigateRecommendations from '@order/steps/templates/Recommendation/useNavigateRecommendations'
import useDealRecommendations from 'features/avatar/useDealRecommendations'
import { useTranslation } from 'react-i18next'
import { RecommendUtils } from 'recommend/RecommendUtils'
import ConfigDebugModal from 'features/debug/ConfigDebugModal'

export default function DealRecommended() {
  const { t } = useTranslation(['configuration'])
  const text = 'configuration:deal.recommended'

  const { rows, recommendations } = useDealRecommendations()
  const { row, animation, next, prev, handleBack } = useNavigateRecommendations(
    { total: rows.length }
  )

  const { selectDeal } = useDealSelect()
  const { toPackages } = useStartOrderConfig()

  const onDealPress = (deal: Deal) => {
    if (!deal) return
    selectDeal({
      deal,
      bundle: 'base',
      onSelected: toPackages,
    })
  }

  const isRecommendation = RecommendUtils.isRecommendation(
    recommendations,
    rows,
    row
  )

  return (
    <>
      <Page stage="deal" back={handleBack}>
        <Header
          title={t(`${text}.header.title`)}
          desc={t(`${text}.header.desc`)}
        />
      </Page>
      <RecommendedBadge hidden={!isRecommendation} />
      <>
        {rows.map((row, index) => (
          <RecommendationRow
            key={index}
            index={index}
            animation={animation}
            total={row.length}
          >
            {row.map((deal) => (
              <DealComponent
                key={deal.id}
                index={index}
                deal={deal}
                grid={2}
                onPress={() => onDealPress(deal)}
              />
            ))}
          </RecommendationRow>
        ))}
      </>
      <ButtonsFixed.Gradient />
      <ConfigDebugModal />
      {rows.map((row, index) => {
        const hasPrev = !!rows[index - 1]
        const hasNext = !!rows[index + 1]
        const showConfirm = row.length === 1

        return (
          <RecommendationButtons
            key={index}
            index={index}
            animation={animation}
            next={next}
            prev={prev}
            onConfirm={showConfirm ? () => onDealPress(row[0]) : undefined}
            hasNext={hasNext}
            hasPrev={hasPrev}
            total={rows[index].length}
          />
        )
      })}
    </>
  )
}
